import { useIsMHD } from "app/frontend/hooks/useIsMHD";
import { useCallback } from "react";

export const useValidatePlug = () => {
    const isMHD = useIsMHD();

    const isValidPlugCount = useCallback(
        (plug: powerready.incentives.IProjectSizePlug) => {
            const min = isMHD ? 2 : 1;
            return plug.count && plug.count < 1000 && plug.count >= min;
        },
        [isMHD],
    );

    const isValidPlugType = useCallback(
        (plug: powerready.incentives.IProjectSizePlug) => {
            return !isMHD || !!plug.plug_type;
        },
        [isMHD],
    );

    const isValidPlugAmount = useCallback((plug: powerready.incentives.IProjectSizePlug) => {
        return plug.amount_kw && plug.amount_kw > 0 && plug.amount_kw <= 1000;
    }, []);

    return useCallback(
        (plug: powerready.incentives.IProjectSizePlug) => {
            return isValidPlugCount(plug) && isValidPlugType(plug) && isValidPlugAmount(plug);
        },
        [isValidPlugAmount, isValidPlugCount, isValidPlugType],
    );
};
